import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'NgbToDate',
    standalone: false
})
export class NgbToDatePipe implements PipeTransform {

  transform(value: { year: number, month: number, day: number}, ...args: any[]): string {
    if (value) {
      const date = new Date(`${value.year}-${('0' + (value.month).toString()).slice(-2)}-${('0' + (value.day).toString()).slice(-2)}`);
      const newdate = new Date(date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000));
          return `${newdate.getFullYear()}-${newdate.getMonth() + 1}-${newdate.getDate()}`;
      }
    return ''; 
  }
  
}
